import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { z } from 'zod'

import BusinessFormField from '../../components/business-form-field'
import BusinessFormTitle from '../../components/business-form-title'
import { useBusinessCreateContext } from '../../context/business-create-context'
import { useBusinessCreateStore } from '../../store/business-create-store'

const FirstNameSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
})
type FirstNameSchemaType = z.infer<typeof FirstNameSchema>

export default function BusinessCreateFirstNameStep() {
  const { setFormData, formData } = useBusinessCreateStore()
  const { handleNext, setFooterConfig } = useBusinessCreateContext()

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FirstNameSchemaType>({
    resolver: zodResolver(FirstNameSchema),
    defaultValues: {
      firstName: formData.consumerFirstName ?? '',
    },
  })

  const firstNameValue = useWatch({
    control,
    name: 'firstName',
  })

  const onSubmit = (data: FirstNameSchemaType) => {
    setFormData({ ...formData, consumerFirstName: data.firstName })
    handleNext()
  }

  useEffect(() => {
    const hasFirstName = !!firstNameValue?.trim()
    setFooterConfig({
      buttonText: hasFirstName ? 'Continue' : 'Skip',
      buttonVariant: hasFirstName ? 'default' : 'ghost',
      primaryAction: hasFirstName ? undefined : () => handleNext(),
    })
  }, [firstNameValue, handleNext, setFooterConfig])

  return (
    <div className="flex size-full flex-col items-center justify-center gap-4">
      <BusinessFormTitle>{`What's your client's first name?`}</BusinessFormTitle>
      <form id="business-create-form" onSubmit={handleSubmit(onSubmit)}>
        <BusinessFormField
          register={register}
          placeholder="First Name"
          name="firstName"
          type="text"
          error={errors.firstName}
          autoFocus={true}
        />
      </form>
    </div>
  )
}
